var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M47.462 24.9121L31.2583 13.245C31.0375 13.0857 30.7722 13 30.5 13C30.2278 13 29.9625 13.0857 29.7417 13.245L13.538 24.9121C13.3716 25.0321 13.2361 25.1898 13.1426 25.3723C13.0491 25.5549 13.0002 25.757 13 25.9621V46.7037C13 47.0475 13.1366 47.3772 13.3797 47.6203C13.6228 47.8634 13.9525 48 14.2963 48H46.7037C47.0475 48 47.3772 47.8634 47.6203 47.6203C47.8634 47.3772 48 47.0475 48 46.7037V25.9621C47.9998 25.757 47.9509 25.5549 47.8574 25.3723C47.7639 25.1898 47.6284 25.0321 47.462 24.9121V24.9121ZM33.7407 45.4073H27.2593V33.7402H33.7407V45.4073ZM45.4074 45.4073H36.3333V32.4438C36.3333 32.1 36.1968 31.7703 35.9537 31.5272C35.7106 31.2841 35.3808 31.1475 35.037 31.1475H25.963C25.6192 31.1475 25.2894 31.2841 25.0463 31.5272C24.8032 31.7703 24.6667 32.1 24.6667 32.4438V45.4073H15.5926V26.6103L30.5 15.8895L45.4074 26.6103V45.4073Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.aaa264e5a5ba740d65f0014b675184b9.svg";
export { ForwardRef as ReactComponent };